'use client';

import {
	BigNum,
	PRICE_PRECISION_EXP,
	MarketType,
} from '@velocity-exchange/sdk';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import useMarketsInfoStore from 'src/stores/useMarketsInfoStore';
import { AccountOpenPosition } from 'src/@types/positions';
import { PRESETS, withDecimals } from 'src/utils/formatNumber/presets';

interface EntryPriceCellProps {
	position: AccountOpenPosition;
}

export function EntryPriceCell({ position }: EntryPriceCellProps) {
	const { entryPrice, marketIndex, isIsolatedBalanceOnly } = position;
	const getMarketInfoByIndexAndType = useMarketsInfoStore(
		(s) => s.getMarketInfoByIndexAndType
	);

	if (isIsolatedBalanceOnly) {
		return <span className="text-text-secondary">-</span>;
	}

	const decimalPlaces = getMarketInfoByIndexAndType(
		marketIndex,
		MarketType.PERP
	)?.genericInfo.priceDisplayDecimals;

	return (
		<NumberDisplay
			value={BigNum.from(entryPrice, PRICE_PRECISION_EXP)}
			options={withDecimals(PRESETS.usdTruncate, decimalPlaces ?? 2)}
		/>
	);
}
